/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Locked, Unlocked } from 'icons';
import shareStore from 'features/share-diagram/share-store';

import * as Styled from './PasswordToggle.styled';

export function PasswordToggle({ togglePasswordControl, toggleRemovePasswordControl }) {
  const { diagram } = shareStore.state;

  let icon;
  let status;
  let action;
  let onClick;

  if (diagram.passwordProtected) {
    icon = <Locked height="16" />;
    status = 'Password-protected';
    action = 'Remove';
    onClick = toggleRemovePasswordControl(true);
  } else {
    icon = <Unlocked height="16" />;
    status = 'Password protect';
    action = 'Add';
    onClick = togglePasswordControl(true);
  }

  return (
    <>
      {icon}
      {/* @ts-expect-error TS2769 */}
      <Styled.Status data-test="share-password-status">{status}</Styled.Status>
      {/* @ts-expect-error TS2769 */}
      <Styled.Action data-test="share-password-toggle" onClick={onClick}>
        {action}
      </Styled.Action>
    </>
  );
}
